import styled from '@emotion/styled';

import LineArrowIcon from '@/assets/icons/icon_line_arrow.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Title = styled.div(() =>
  mq({
    display: 'flex',
    alignItems: 'center',
    fontSize: defaultTheme.font.size.xs,
    color: defaultTheme.color.grayScale.dark,
    marginBottom: defaultTheme.spacing.s,
    '&::before': {
      content: '""',
      display: 'inline-block',
      width: '12px',
      height: '12px',
      backgroundImage: `url(${LineArrowIcon})`,
      backgroundCover: 'contain',
      backgroundRepeat: 'no-repeat',
      marginRight: defaultTheme.spacing.xs,
    },
  }),
);

export const Wrapper = styled.div(() =>
  mq({
    display: 'flex',
    width: 'max-content',
  }),
);

export const Column = styled.div(() =>
  mq({
    display: 'grid',
    gridAutoRows: '24px',
    gap: '2px',
    minWidth: ['10px', '10px', '12px', '12px'],
    marginLeft: '2px',
    '&:first-of-type': {
      marginLeft: '0',
    },
    '@media (max-width:320px)': { minWidth: '4px' },
  }),
);
